/*
isEmail
*/
const isEmail = (val) => {
  // original regex (remove unnecessary escape character: \)
  // const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(val).toLowerCase())
}

export default (value) => {
  const val = value.trim()

  if (isEmail(val)) {
    return {
      name: val,
      email: val
    }
  }

  // original regex (remove unnecessary escape character: \)
  // const regexEmail = '([a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)'
  // const regex = new RegExp('^([^<]*)\<' + regexEmail + '\>$', 'i')
  const regexEmail = '([a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)'
  const regex = new RegExp('^([^<]*)<' + regexEmail + '>$', 'i')

  const extract = val.match(regex)

  if (extract && extract[2]) {
    return {
      name: extract[1].trim() || extract[2].trim(),
      email: extract[2].trim()
    }
  }

  return null
}



// WEBPACK FOOTER //
// ./src/utils/ExtractEmail.js